// ============================================================================
// Wie ein Name dasteht.
//
// ORIGINALTEXT MARVIN (03.09.2026)
//   „Und es reicht dort der Vorname, der Nachname muss nicht angezeigt
//    werden."
//
// SIE STEHEN IN EINER EIGENEN DATEI OHNE JSX, damit ein Prüfstand sie
// NACHRECHNEN kann. `Person.tsx` zeichnet einen Kreis und lässt sich mit
// `--experimental-strip-types` nicht laden; eine Regel, die nur dort stünde,
// wäre nur über eine Textsuche zu prüfen - und eine Textsuche misst, dass
// etwas dasteht, nicht, dass es stimmt. Dieselbe Aufteilung wie bei
// `ordnerabwurf.ts` und `bildverkleinern.ts`.
// ============================================================================

/** Das erste Wort eines Namens. „Marvin Schumann" wird „Marvin". */
export function vorname(name: string): string {
  const teile = (name ?? '').trim().split(/\s+/).filter(Boolean);
  return teile.length ? teile[0] : (name ?? '').trim();
}

/** Die ersten Buchstaben von Vor- und Nachnamen. „Marvin Schumann" wird MS. */
export function initialen(name: string): string {
  const teile = (name ?? '').trim().split(/\s+/).filter(Boolean);
  if (!teile.length) return '?';
  if (teile.length === 1) return teile[0].slice(0, 2).toUpperCase();
  return (teile[0][0] + teile[teile.length - 1][0]).toUpperCase();
}

/**
 * WIE EIN NAME IN EINER LISTE DASTEHT.
 *
 * Der Vorname - und der VOLLE Name, sobald in derselben Liste zwei
 * VERSCHIEDENE Menschen denselben Vornamen tragen. Ein Vorname, der zwei
 * Menschen meinen kann, ist keine Auskunft, und die Auftragsinfo ist das,
 * worauf sich später jemand beruft.
 *
 * ZWEI SCHREIBWEISEN SIND NICHT ZWEI MENSCHEN. In den übernommenen Einträgen
 * steht „Marvin", in den neuen „Marvin Schumann" - derselbe Mensch, und der
 * Server sagt es: er löst beide auf dieselbe Kennung auf (`gesicht_id`).
 * Verglichen wird deshalb die KENNUNG, wo es eine gibt, und nur sonst der
 * geschriebene Name. Ohne das stünde in der halben Liste ein voller Name,
 * weil derselbe Mensch zweimal verschieden geschrieben ist.
 *
 * Zurück kommt eine Karte vom VOLLEN Namen auf das, was dastehen soll.
 */
export function kurzeNamen(
  leute: readonly { name?: string | null; wer?: string | null }[]
): Map<string, string> {
  /* Erst: welcher Name hat eine Kennung? Ein Name OHNE Kennung - der
     Berichtigende hat keine - erbt sie von seinem Namensvetter mit Kennung.
     Ohne diesen Schritt wären „Marvin Schumann" als Verfasser und derselbe
     „Marvin Schumann" als Berichtigender zwei Menschen. */
  const kennung = new Map<string, string>();
  for (const l of leute) {
    const voll = (l.name ?? '').trim();
    if (voll && l.wer && !kennung.has(voll)) kennung.set(voll, l.wer);
  }

  const proVorname = new Map<string, { namen: Set<string>; wer: Set<string> }>();
  for (const l of leute) {
    const voll = (l.name ?? '').trim();
    if (!voll) continue;
    const v = vorname(voll).toLowerCase();
    let g = proVorname.get(v);
    if (!g) { g = { namen: new Set(), wer: new Set() }; proVorname.set(v, g); }
    g.namen.add(voll);
    g.wer.add(kennung.get(voll) ?? voll.toLowerCase());
  }

  const karte = new Map<string, string>();
  for (const g of proVorname.values()) {
    const eindeutig = g.wer.size <= 1;
    for (const voll of g.namen) karte.set(voll, eindeutig ? vorname(voll) : voll);
  }
  return karte;
}
